// extracted by mini-css-extract-plugin
module.exports = {"heading":"heading_heading__Pro_v"};